<template>
  <div>
    <b-row class="mt-2">
      <b-col cols="12">
        <base-action-table
          :records="records"
          :fields="fields"
          :busy="isBusy"
          :filtering="filtering"
          :module="module"
          @creating="handleCreating"
          @detail="handleDetail"
          @editing="handleEditing"
          @deleting="handleDeleting"
        >
        </base-action-table>
      </b-col>
    </b-row>
    <base-modal :title="title" :id="id">
      <template v-slot:form>
        <form-add-baby
          :isDisabled="isDisabled"
          :record="record"
          :baby="baby"
          @save="update"
        />
      </template>
    </base-modal>
  </div>
</template>

<script>
import ActionCRUD from "@/mixins/ActionCRUD";
//Components
import { BCol, BRow, VBTooltip } from "bootstrap-vue";
import BaseActionTable from "@/components/base/BaseActionTable";
import BaseModal from "@/components/base/BaseModal";
import FormAddBaby from "./FormAddBaby";

export default {
  inject: ["babyRepository"],
  mixins: [ActionCRUD],
  components: {
    BCol,
    BRow,
    BaseActionTable,
    BaseModal,
    FormAddBaby,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    baby: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      record: null,
      records: [],
      fields: [
        {
          key: "names",
          label: "Nombres",
        },
        {
          key: "last_names",
          label: "Apellidos",
        },
        {
          key: "type_identification",
          label: "Tipo de identificación",
        },
        {
          key: "identification",
          label: "Identificación",
        },
        {
          key: "age",
          label: "Edad",
        },
        { key: "actions", label: "Accion" },
      ],
      isBusy: false,
      filtering: false,
      isDisabled: false,
      id: "modal-add-baby",
      title: "Agregar bebe",
      module: "5df61d1b-fe0f-46aa-bd74-49ffdebc6868",
    };
  },
  mounted() {
    const me = this;
    me.loadAccompanist();
  },
  methods: {
    async loadAccompanist() {
      const me = this;
      try {
        me.isBusy = true;
        const { data } = await me.babyRepository.getAll(
          me.baby.accompanistUuid
        );
        me.records = data;
      } catch (error) {
        const { status } = error.data;
        if (status == 419) {
          me.$bvModal.show("expired-token-model");
        } else if (status == 403) {
          me.$bvModal.show("session-finish-modal");
        }
      } finally {
        me.isBusy = false;
      }
    },
    handleCreating() {
      const me = this;
      if (me.records.length == 0 || me.records.length > 2) {
        me.title = "Agregar bebe";
        me.isDisabled = false;
        me.record = null;
        me.$bvModal.show(me.id);
      }
    },
    handleEditing(item) {
      const me = this;
      me.title = "Actualizar Bebe";
      me.isDisabled = false;
      me.record = item;
      me.$bvModal.show(me.id);
    },
    handleDetail(item) {
      const me = this;
      me.title = "Detalle Bebe";
      me.isDisabled = true;
      me.record = item;
      me.$bvModal.show(me.id);
    },
    async handleDeleting(uuid) {
      const me = this
      me.$bvModal.msgBoxConfirm('¿Seguro que deseas eliminar este registro?', {
        title: 'Confirmar eliminación',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Si',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(async (value) => {
          if (value) {
            try {
              await me.babyRepository.delete(uuid)

              me.messageSuccess('Registro eliminado', 'Registro eliminado con exito');
              me.loadAccompanist()
            } catch (error) {
              const { message, status } = error.data;
              if (status == 419) {
                me.$bvModal.show("expired-token-model");
              } else if (status == 403) {
                me.$bvModal.show("session-finish-modal");
              }
              let title = 'Error al eliminar registro' 
              let messageErr = 'Registro no Eliminado.';

              me.messageError(title, messageErr, "icon-message-error");
            }
            
          }
        })
    },
    update() {
      const me = this;
      me.messageSuccess();
      me.loadAccompanist();
      me.$bvModal.hide(me.id);
    },
  },
};
</script>

<style></style>
